import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * Miniature produit pour les listes catalogue (recherche, boutique).
 * Sans photo : pastille neutre avec l'initiale, pour garder l'alignement.
 */
@Component({
  selector: 'ct-product-thumb',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="thumb" aria-hidden="true">
      @if (src(); as url) {
        <img [src]="url" [alt]="" loading="lazy" decoding="async" />
      } @else {
        <span class="fallback">{{ initial() }}</span>
      }
    </span>
  `,
  styles: `
    :host {
      display: block;
      flex-shrink: 0;
    }

    .thumb {
      display: grid;
      place-items: center;
      width: 2.75rem;
      height: 2.75rem;
      overflow: hidden;
      border-radius: var(--ct-radius-md);
      background: var(--ct-kraft);
      border: 1px solid var(--ct-border);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    .fallback {
      font-family: var(--ct-font-title);
      font-size: var(--ct-size-sm);
      font-weight: var(--ct-weight-bold);
      color: var(--ct-text-muted);
      line-height: 1;
      text-transform: uppercase;
    }
  `,
})
export class CtProductThumb {
  readonly photoUrl = input<string | undefined>();
  readonly name = input.required<string>();

  protected readonly src = computed(() => {
    const url = this.photoUrl()?.trim();
    return url && url.length > 0 ? url : undefined;
  });

  protected readonly initial = computed(() => {
    const letter = this.name().trim().match(/\p{Letter}/u)?.[0];
    return letter?.toUpperCase() ?? '·';
  });
}
